import { useEffect } from 'react'
import { NavigationType, useLocation, useNavigationType } from 'react-router'

/**
 * Starts every new page at the top.
 *
 * A single-page app does not reload on navigation, so the browser leaves the
 * scroll position exactly where it was — click a piece from halfway down the
 * gallery and its page opens halfway down too, past the photograph.
 *
 * Going *back* is the exception: there the browser's own restoration is
 * correct and welcome, because it returns the visitor to the tile they came
 * from instead of the top of a long grid. React Router reports that as a POP
 * navigation, which is left alone.
 */
export function ScrollToTop() {
  const { pathname } = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    if (navigationType === NavigationType.Pop) return

    // 'instant' rather than the smooth scrolling set globally in CSS: on a new
    // page there is nothing to follow visually, and animating a jump the
    // visitor did not ask for just delays what they came to see.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname, navigationType])

  return null
}
